/* eslint-disable */

import type { AccountingLang } from "./types/AccountingLang";

let data: AccountingLang | undefined;

export type { AccountingLang };

export default function AccountingLangFactory(): AccountingLang {
  if (!data) {
    throw new Error("Trying to load a language in the main bundle before the language bundle is loaded");
  }
  return data;
}

export let setAccountingLang = (newLang: string) => {
  if (newLang === "en-GB") {
      return import(/* webpackChunkName: "en-GB.locale" */ "./en-GB/AccountingLangDef").then(({ AccountingLangDef }) => {
      data = AccountingLangDef;
    });
  } else if (newLang === "sv-SE") {
      return import(/* webpackChunkName: "sv-SE.locale" */ "./sv-SE/AccountingLangDef").then(({ AccountingLangDef }) => {
      data = AccountingLangDef;
    });
  } else if (newLang === "en-SE") {
      return import(/* webpackChunkName: "en-SE.locale" */ "./en-SE/AccountingLangDef").then(({ AccountingLangDef }) => {
      data = AccountingLangDef;
    });
  } else if (newLang === "ky-KG") {
      return import(/* webpackChunkName: "ky-KG.locale" */ "./ky-KG/AccountingLangDef").then(({ AccountingLangDef }) => {
      data = AccountingLangDef;
    });
  }
  else {
    throw new Error("Unsupported language/culture " + newLang);
  }
};

